import {ACTION_MADE_FROM_ENUM} from '~/shared/utils/ageRestriction';
import {makeActionCreator} from '~/shared/store/redux-toolbelt';

export const setActionMadeFrom = makeActionCreator<'setActionMadeFrom', ACTION_MADE_FROM_ENUM>('setActionMadeFrom');
export const setIsAgeConfirmed = makeActionCreator<'setIsAgeConfirmed', boolean>('setIsAgeConfirmed');
